import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Renewal Details</h3>
                <p className="text-sm text-gray-600">
                    Detailed information and historical records for a specific documentation renewal.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Renewal Tracking</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Expenses:</strong> Track costs specifically attributed to this renewal event.</li>
                    <li><strong>Media:</strong> Store digital copies of licenses, policy documents, or inspection certificates.</li>
                    <li><strong>Notes:</strong> Internal commentary or record-keeping for the renewal process.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Validity Monitoring</h4>
                <p className="text-sm text-gray-600">
                    Ensure the document remains valid. The header displays the vehicle and the type of document being tracked.
                </p>
            </section>
        </div>
    );
};

export default Help;
